// extracted by mini-css-extract-plugin
export default {"imgWrap":"_cn6g6"};